<template>
  <el-dialog
    :visible.sync="visible"
    title="查看合同"
    width="660px"
    :before-close="handleClose"
  >
    <el-form
      :model="contractForm"
      ref="contractFormRef"
      label-width="80px"
      :disabled="true"
    >
      <el-form-item label="合同名称" prop="contractName">
        <el-input
          v-model="contractForm.contractName"
          placeholder="请输入合同名称"
        />
      </el-form-item>
       <el-form-item label="合同编码" prop="contractCode">
        <el-input
          v-model="contractForm.contractCode"
          placeholder="请输入合同编码"
        />
      </el-form-item>
      <el-form-item label="签署方一" prop="draftShopName">
        <el-input
          v-model="contractForm.draftShopName"
          placeholder="请选择签署方"
        />
      </el-form-item>
      <el-form-item label="签署方二" prop="coopShopId">
        <el-input
          v-model="contractForm.coopShopName"
          placeholder="请选择签署方"
        />
      </el-form-item>
    </el-form>
    <div class="upload-container">
      <div class="value input fill">
        <ossFileUpload
          ref="refPicFileUpload"
          v-model="picFileList"
          :limit="maxFileCount"
          :accept="picFileExt"
          :maxFileLength="10"
          :ossUpload="true"
          :ossPathDir="'shop/pic/'"
          style="margin-bottom: 10px"
          :disabled="isDisabled"
          :onPreview="handlePreview"
        >
        </ossFileUpload>
        <div class="small-tip warning" v-if="!isDisabled">
          <span
            >最多支持{{ maxFileCount }}张，单张不超过10M； 支持{{
              picFileExt
            }}</span
          >
        </div>
      </div>
    </div>
    <!-- 审核区域 -->
    <div class="audit-section">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item label="审核结果" prop="auditResult">
          <el-radio-group
            v-model="form.auditResult"
            @change="handleAuditChange"
            :disabled="checkDisable"
          >
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 驳回理由 -->
        <el-form-item
          v-if="form.auditResult === 2"
          label="驳回理由"
          prop="rejectReason"
        >
          <el-input
            type="textarea"
            v-model="form.rejectReason"
            placeholder="请输入驳回理由"
            :disabled="checkDisable"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="submitUpload"
        :loading="uploading"
        v-show="!checkDisable"
      >
        提交
      </el-button>
    </div>
    <FileViewer ref="fileViewerRef" />
  </el-dialog>
</template>

<script>
import FileViewer from "@/components/FileViewer";
import ossFileUpload from "@/components/ossFileUpload";
import { getToken } from "@/utils/auth";
import {
  uploadContractFile,
  csoAuditContract,
} from "@/api/compliance/contractManager";
import { getOssSrcFileName } from "@/utils/oss";

export default {
  name: "ContractFileUpload",
  components: {
    ossFileUpload,
    FileViewer,
  },
  props: {},
  data() {
    return {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      uploading: false,
      picFileList: [],
      picFileExt: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
      maxFileCount: 9,
      isDisabled: true,
      visible: false,
      contractId: "",
      // 审核相关
      form: {
        auditResult: null, // 1:通过, 2:驳回
        rejectReason: "",
      },
      rules: {
        auditResult: [
          { required: true, message: "请选择审核结果", trigger: "blur" },
        ],
        rejectReason: [
          { required: true, message: "请输入驳回理由", trigger: "blur" },
        ],
      },
      checkDisable: false,
      contractForm: {
        contractName: "",
        contractCode: "",
        draftShopName: "",
        coopShopName: "",
      },
    };
  },
  methods: {
    handlePreview(file) {
      const { url } = file;
      if (url) {
        this.$refs.fileViewerRef.publicOpen(url);
      }
    },
    handleClose() {
      this.visible = false;
      this.picFileList = [];
      this.form.rejectReason = "";
      this.$refs.formRef.resetFields();
      this.$refs.refPicFileUpload.release();
    },
    publicOpen(contract) {
      const { id, fileUrl, checkStatus, checkRemark, contractName, contractCode, draftShopName, coopShopName } = contract;
      this.contractForm.contractName = contractName;
      this.contractForm.contractCode = contractCode;
      this.contractForm.draftShopName = draftShopName;
      this.contractForm.coopShopName = coopShopName;
      this.form.auditResult = checkStatus;
      if (checkStatus == 2) {
        this.form.rejectReason = checkRemark;
      }
      this.checkDisable = checkStatus !== 0;
      if (fileUrl) {
        const urls = fileUrl.split(",");
        this.picFileList = urls.map((item) => {
          return this.parseToUploadUrl(item);
        });
      }else{
        this.picFileList = [];
      }
      this.visible = true;
      this.contractId = id;
      this.$nextTick(() => {
        this.$refs.refPicFileUpload.init(); //初始化oss上传
      });
    },
    // 审核结果变更
    handleAuditChange(val) {
      this.auditResult = val;
      if (val !== 2) {
        this.rejectReason = "";
      }
    },
    submitUpload() {
      // 验证表单
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.uploading = true;
          //           @Schema(description = "审核状态（0：待审核，1：通过：2：未通过）")
          // private Integer checkStatus;

          // @Schema(description = "审核备注")
          // private String checkRemark;
          // 准备提交数据
          const submitData = {
            id: this.contractId,
            checkStatus: this.form.auditResult,
            checkRemark: this.form.rejectReason,
          };
          csoAuditContract(submitData)
            .then((res) => {
              this.uploading = false;
              if (res) {
                this.$message.success("提交成功");
                this.visible = false;
                this.$emit("uploadSuccess");
              }
            })
            .catch(() => {
              this.uploading = false;
            });
        }
      });
    },
    parseToUploadUrl(newUrl) {
      if (newUrl) {
        const name = getOssSrcFileName(newUrl);
        return {
          name: name,
          url: newUrl,
          response: { data: { fileName: name, url: newUrl } },
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
.upload-container {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: right;
}

.audit-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.el-form-item {
  margin-bottom: 15px;
}
</style>